module.exports = __webpack_public_path__ + "static/timelinemay2012-925f65931e8c4a1c7b3e36cb7cb049f8.jpeg";